import React from "react";
import { education } from "./education";
import { works } from "./works";
import img1 from "./assets/img.jpeg";

const CV = () => {
  return (
    <div className="p-5 sm:p-10 md:p-16 min-h-screen bg-blue-50">
      <h1 className="mb-8 text-5xl">Curriculum Vitae</h1>

      <div className="grid grid-cols-2 gap-6">
        <div className="p-8 shadow-lg rounded-2xl bg-white col-span-2 sm:col-span-1">
          <h2 className="mb-8 text-3xl">Information</h2>
          <div className="flex flex-col items-center sm:flex-row ">
            <div className="flex-grow">
              <img className="rounded-full h-32 border shadow-lg" src={img1} />
            </div>
            <div className="mt-2">
              <div className="font-medium text-xl mb-2 text-center sm:text-right">
                Ing. Martin Schnurer
              </div>
              <div className="text-center sm:text-right">* 14.7.1995</div>
              <div className="text-center sm:text-right">Slovakia</div>
            </div>
          </div>
        </div>

        <div className="p-8 shadow-lg rounded-2xl bg-white col-span-2 sm:col-span-1">
          <h2 className="mb-8 text-3xl">Contact</h2>
          <div>
            <div>martin.schnurer@gmail.com</div>
            <div>+421 950 210 320</div>
            <div>
              <a href="/portfolio">Portfolio</a>
            </div>
          </div>
        </div>

        {/* WORK */}
        <div className="p-8 shadow-lg rounded-2xl bg-white col-span-2 sm:col-span-1">
          <h2 className="mb-8 text-3xl">Work experience</h2>

          {works.map((work) => (
            <div key={work.name} className="relative pb-8">
              <div className="pl-4 ">
                <h1 className="text-xl font-bold">{work.name}</h1>
                {work.position && (
                  <div className="mb-1 -mt-1 italic text-sm font-light">
                    {work.position}
                  </div>
                )}
                <h2 className="text-base text-gray-700 font-light pb-3">
                  {work.dates}
                </h2>
                {work.description && (
                  <div className="text-gray-500 font-light">
                    {work.description}
                  </div>
                )}
                {work.technologies.length > 0 && (
                  <div className="text-xs font-light">
                    <u>Stack:</u> {work.technologies.join(", ")}
                  </div>
                )}
              </div>
              <div className="absolute l-50 top-2/4 h-2/4 bg-gray-300 w-px" />
              <div className="absolute l-50 top-0 h-2/4 bg-gray-300 w-px" />
              <div
                style={{ left: "-0.25rem" }}
                className="absolute l-50 top-3 w-2 h-2 rounded-full bg-green-600"
              />
            </div>
          ))}
        </div>
        <div className="p-8 shadow-lg rounded-2xl bg-white col-span-2 sm:col-span-1">
          <h2 className="mb-8 text-3xl">Education</h2>

          {education.map((edu) => (
            <div key={edu.name + edu.dates} className="relative pb-8">
              <div className="pl-4 ">
                <h1 className="text-xl font-bold">{edu.name}</h1>
                {edu.subtitle && <h2>{edu.subtitle}</h2>}

                <h2 className="text-sm text-gray-700 font-light pb-3">
                  {edu.dates}
                </h2>
                <div className="text-gray-500 font-light">{}</div>
              </div>
              <div className="absolute l-50 top-2/4 h-2/4 bg-gray-300 w-px" />
              <div className="absolute l-50 top-0 h-2/4 bg-gray-300 w-px" />
              <div
                style={{ left: "-0.25rem" }}
                className="absolute l-50 top-3 w-2 h-2 rounded-full bg-blue-600"
              />
            </div>
          ))}
        </div>

        {/* Skills */}
        <div className="p-8 shadow-lg rounded-2xl bg-white col-span-2 sm:col-span-1">
          <h2 className="mb-6 text-3xl ">Skills</h2>
          <div className="text-lg">
            <div>Javascript + Typescript</div>
            <div>React (+ all hooks)</div>
            <div>GatsbyJS</div>
            <div>HTML5 + CSS3</div>
            <div>Redux {"&"} Context</div>
            <div>GraphQL</div>
            <div>AWS DynamoDB</div>
            <div>AWS Lambda</div>
            <div>AWS API Gateway</div>
            <div>AWS Step Functions</div>
            <div>Serverless Framework</div>
            <div>Node.js</div>
            <div>git</div>
            <div>Styled-components, Tailwind, CSS-modules</div>
            <div>React-dnd (Drag and Drop)</div>
            <div>PostgreSQL</div>
            <div>Recharts.js</div>
          </div>
        </div>

        {/* Languages */}
        <div className="p-8 shadow-lg rounded-2xl bg-white col-span-2 sm:col-span-1">
          <h2 className="mb-4 text-3xl ">Languages</h2>
          <div className="p-3 shadow mb-3">
            <b>Slovak</b> - Fluent
          </div>
          <div className="p-3 shadow mb-3">
            <b>English</b> - B2
          </div>
          <div className="p-3 shadow mb-3">
            <b>German</b> - Basics
          </div>
        </div>

        {/* BOTTOM LINE */}
        <div className="p-8 shadow-lg rounded-2xl bg-white col-span-2">
          <h2 className="mb-8 text-3xl ">Bottom Line</h2>
          <div>
            I like when the work is done simply and with a common sense.
          </div>
          <div>
            Overcomplicating and overengineering are things I'm not familiar
            with.
          </div>
          <div>I like biking and hiking.</div>
        </div>
      </div>
    </div>
  );
};

export default CV;
